import React, { createContext, useState } from 'react';

// Create a new context
const ConfigContext = createContext();

// Create a provider component
const ConfigContextProvider = ({ children }) => {
  // Define your predefined variables
  const [appConfig, setConfig] = useState({
    jql: "",
    "selectedFields": [],
    masterDetail: true
  });
  const [sheetType, setSheetType] = useState('default');
  const [readOnlyMode, setReadOnlyMode] = useState(false)
  const [globalStyle, setGlobalStyle] = useState({})
  const [corruptedNodes,setCorruptedNodes] = useState([])
  const [selectedColumns,setSelectedColumns] = useState([])

  // Define your functions
  const setConfigHelper = (fieldsToChange) => {
    let obj = { ...appConfig }
    Object.keys(fieldsToChange).forEach((field) => {
      obj[field] = fieldsToChange[field]
    })
    // Function logic here
    setConfig(obj);
  };

  // Create an object with the values to be provided
  const contextValues = {
    appConfig,
    sheetType,
    readOnlyMode,
    globalStyle,
    corruptedNodes,
    selectedColumns,
    setConfigHelper,
    setSheetType,
    setReadOnlyMode,
    setGlobalStyle,
    setCorruptedNodes,
    setSelectedColumns
  };

  // Provide the context values to the children components
  return <ConfigContext.Provider value={contextValues}>{children}</ConfigContext.Provider>;
};

export { ConfigContext, ConfigContextProvider };
